import flatpickr from "flatpickr";
import 'flatpickr/dist/flatpickr.css'
import "flatpickr/dist/l10n/zh-tw"

function initializePickers(showModelPicker = false) {
    $('.datepicker').flatpickr({
        static: showModelPicker
    });
    $('.datepicker-zh').flatpickr({
        locale: "zh_tw",
        static: showModelPicker
    });
    $('.clockpicker').flatpickr({
        enableTime: true,
        noCalendar: true,
        dateFormat: "H:i",
        time_24hr: false,
        static: showModelPicker
    });
    $('.datetimepicker').flatpickr({
        enableTime: true,
        time_24hr: true,
        static: showModelPicker
    });
    $('.datetimesecpickr').flatpickr({
        enableTime: true,
        time_24hr: true,
        enableSeconds: true,
        dateFormat: "Y-m-d H:i:S",
        static: showModelPicker
    });
}

document.addEventListener('DOMContentLoaded', function () {
    let showModelPicker = document.querySelectorAll('#advanced-search').length > 0;

    // 初始化所有 picker
    initializePickers(showModelPicker);

    $('.row1').on('click', '.add_fields', function (event) {
        setTimeout(initializePickers, 100);
    });
});

// var exportModal = document.getElementById('export_file')
// exportModal.addEventListener('show.bs.modal', function (event) {
//     $("#export_file").find(".datetime").flatpickr();
// })